/** Value kinds are separate figures (GP-16); never summed with one another. */ export const VALUE_KINDS = [
    {
        key: 'deal',
        label: 'Estimated deal value'
    },
    {
        key: 'share',
        label: 'Expected company share'
    },
    {
        key: 'bid',
        label: 'Submitted price'
    },
    {
        key: 'award',
        label: 'Awarded value'
    },
    {
        key: 'revenue',
        label: 'Authorized actual revenue'
    }
];
/** 'USD 100000.00; EUR 7.00' — exact server decimals, one entry per currency. */ export function amountsText(totals) {
    return totals.map((m)=>`${m.currency} ${m.amount}`).join('; ');
}
/** Display only: currencies are listed side by side, never converted or added. */ export function formatMoney(m) {
    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: m.currency
        }).format(Number(m.amount));
    } catch  {
        return `${m.currency} ${m.amount}`;
    }
}
const csvCell = (v)=>{
    const s = String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};
const HEADER = [
    'scope',
    'landscape_id',
    'landscape',
    'opportunities',
    ...VALUE_KINDS.map((k)=>k.key),
    'pursuits',
    'proposals'
];
function csvRow(scope, id, name, f) {
    return [
        scope,
        id,
        name,
        f.opportunityCount,
        ...VALUE_KINDS.map((k)=>amountsText(f[k.key])),
        f.pursuitCount,
        f.proposalCount
    ].map(csvCell).join(',');
}
/** Serializes the single RPC response as-is: the portfolio row, then each Landscape. */ export function economicsCsv(r) {
    const rows = [
        HEADER.join(',')
    ];
    if (r.portfolio) rows.push(csvRow('portfolio', '', '', r.portfolio));
    for (const l of r.landscapes){
        if (l.figures) rows.push(csvRow('landscape', l.landscapeId, l.name, l.figures));
    }
    return `${rows.join('\n')}\n`;
}
export function downloadCsv(filename, csv) {
    const url = URL.createObjectURL(new Blob([
        csv
    ], {
        type: 'text/csv;charset=utf-8'
    }));
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
}
